import { keyframes } from '@mui/system';

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const slideUp = keyframes`
  0% {
    transform: translateY(50%);
  }
  100% {
    transform: translateY(-50%);
  }
`;

export const fadeOut = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
`;

export const growHeightFadeIn = keyframes`
  0% {
    height: 0%;
    opacity: 0;
  }
  50% {
    height: 95%;
    opacity: 0;
  }
  100% {
    height: 100%;
    opacity: 1;
  }
`;
